"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var SearchMethods = _interopRequireWildcard(require("./Search"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Search2 = _interopRequireDefault(require("@mui/icons-material/Search"));
var _classnames = _interopRequireDefault(require("classnames"));
var _object = require("../../utils/type-checks/object");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge");

/**
 * Search Button, loosely coupled to Search Component with PubSub Event
 *
 * @visibleName Search Button
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
const SearchButton = props => {
  if (!(0, _object.isObject)(window.PubSub)) {
    window.PubSub = require("pubsub-js");
  }
  const {
      ariaExpanded = false,
      ariaLabel = "Open Search Panel",
      className,
      customTheme,
      searchId,
      styles = {},
      testId,
      ...rest
    } = props,
    buttonClasses = (0, _classnames.default)({
      "Search__button": true,
      [`${className}`]: className
    }),
    [expanded, setExpanded] = (0, _react.useState)(ariaExpanded);
  (0, _react.useEffect)(() => {
    const openToken = window.PubSub.subscribe("search.open", () => {
        SearchMethods.HandleSetter(true, setExpanded);
      }),
      closeToken = window.PubSub.subscribe("search.close", () => {
        SearchMethods.HandleSetter(false, setExpanded);
      });
    return () => {
      window.PubSub.unsubscribe(openToken);
      window.PubSub.unsubscribe(closeToken);
    };
  }, [setExpanded]);
  return /*#__PURE__*/_react.default.createElement(_material.IconButton, _extends({
    "aria-controls": searchId,
    "aria-expanded": expanded,
    "aria-haspopup": "dialog",
    "aria-label": ariaLabel,
    className: buttonClasses,
    "data-testid": testId,
    id: "search__button-id",
    onBlur: () => SearchMethods.MoveFocus("input.Search__input"),
    onClick: () => window.PubSub.publish("search.open"),
    sx: merge({
      display: "inline-flex",
      padding: "0",
      "&.Search--isNavigation": {
        marginLeft: "2rem"
      },
      "svg": {
        fill: "#004569",
        height: "4.1rem",
        width: "4.1rem"
      }
    }, styles)
  }, rest), /*#__PURE__*/_react.default.createElement(_Search2.default, {
    "aria-hidden": undefined
  }));
};

// Define propTypes;
SearchButton.propTypes = {
  /** expanded state of search component */
  ariaExpanded: _propTypes.default.bool,
  /** String for Button Label */
  ariaLabel: _propTypes.default.string,
  /** Custom classname(s) */
  className: _propTypes.default.string,
  /** String identifing search block for aria-controls */
  searchId: _propTypes.default.string.isRequired,
  /** Custom styles object */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string
};
var _default = exports.default = SearchButton;